export enum Colors {
    GRAY = '#535353',
    BLUE = '#1976d1',
}
